"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderType = void 0;
const validation_1 = require("../validation");
/**
 * Different supported providers
 * @alpha
 */
var ProviderType;
(function (ProviderType) {
    ProviderType["INJECTED"] = "injected";
    ProviderType["MAGIC"] = "magic";
    ProviderType["FORTMATIC"] = "formatic";
    ProviderType["NETWORK"] = "network";
    ProviderType["WALLET_CONNECT"] = "wallet_connect";
    ProviderType["WALLET_CONNECT_V2"] = "wallet_connect_v2";
    ProviderType["WALLET_LINK"] = "wallet_link";
    ProviderType["METAMASK_MOBILE"] = "metamask_mobile";
    ProviderType["AUTH_SERVER"] = "auth_server";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
/**
 * @alpha
 */
(function (ProviderType) {
    ProviderType.schema = {
        type: 'string',
        enum: Object.values(ProviderType)
    };
    ProviderType.validate = (0, validation_1.generateLazyValidator)(ProviderType.schema);
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
//# sourceMappingURL=provider-type.js.map